import { api } from '../api/client';
import type { ScriptStyle } from '../types/api';

const FALLBACK_STYLES: ScriptStyle[] = [
  {
    style_id: '科普口播稿',
    display_name: '科普口播稿',
    description: '生动有趣的科普内容，适合社会公众',
    target_audience: '社会公众',
    tone: '生动有趣、亲和力强',
    language_features: ['通俗易懂', '实用价值', '逻辑清晰', '引人入胜', '生动比喻', '对话感强'],
  },
  {
    style_id: '研究分析口播稿',
    display_name: '研究分析口播稿',
    description: '学术研究深度分析，适合专业听众',
    target_audience: '学术研究人员、专业人士',
    tone: '客观严谨、深度分析',
    language_features: ['学术严谨', '逻辑严密', '客观中立', '深度思考', '证据导向', '批判思维'],
  },
  {
    style_id: '音频新闻简讯口播稿',
    display_name: '音频新闻简讯口播稿',
    description: '简洁明了的资讯播报，突出核心信息',
    target_audience: '普通听众、资讯关注者',
    tone: '简洁明了、客观准确',
    language_features: ['简洁明了', '客观中性', '专业规范', '信息密集', '快速传达', '重点突出'],
  },
];

let cachedStyles: ScriptStyle[] = [...FALLBACK_STYLES];
let loadingPromise: Promise<ScriptStyle[]> | null = null;
let loadedFromServer = false;

export async function ensureScriptStyles(forceRefresh = false): Promise<ScriptStyle[]> {
  if (loadedFromServer && !forceRefresh) {
    return cachedStyles;
  }

  if (!loadingPromise) {
    loadingPromise = api
      .getScriptStyles()
      .then((payload) => {
        if (payload.styles && payload.styles.length) {
          cachedStyles = payload.styles;
        } else {
          console.warn('未能获取可用风格，继续使用本地默认配置');
        }
        loadedFromServer = true;
        return cachedStyles;
      })
      .catch((error) => {
        console.error('获取脚本风格失败:', error);
        loadedFromServer = true;
        return cachedStyles;
      })
      .finally(() => {
        loadingPromise = null;
      });
  }

  return loadingPromise;
}

export function getScriptStyleOptions(): ScriptStyle[] {
  return cachedStyles;
}

export function findScriptStyleById(id?: string): ScriptStyle | null {
  if (!id) {
    return cachedStyles[0] || null;
  }
  return cachedStyles.find((style) => style.style_id === id) || cachedStyles[0] || null;
}